module.exports = __webpack_public_path__ + "static/img/hjk_tit_img.fdb9400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/hjk_tit_img.png
// module id = 7GVu
// module chunks = 0